import { Box, Typography, CircularProgress, Alert } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DataObjectIcon from "@mui/icons-material/DataObject";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export function LoadingDisplay() {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', gap: 2 }}>
            <CircularProgress size={40} />
            <Typography variant="body1" color="text.secondary">
                Loading analytics data...
            </Typography>
        </Box>
    );
}

export function ErrorDisplay({ error }: { error: string }) {
    return (
        <Alert 
            severity="error" 
            icon={<ErrorOutlineIcon />}
            sx={{ 
                mb: 2,
                '& .MuiAlert-message': {
                    width: '100%'
                }
            }}
        >
            <Typography variant="body2" component="div">
                <strong>Error:</strong> {error}
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                Please check your selections and try again. Ensure you have selected both a storage location and at least one metric.
            </Typography>
        </Alert>
    );
}

export function NoMetricsSelectedDisplay() {
    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            flexDirection: 'column',
            gap: 2,
            py: 4
        }}>
            <DataObjectIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
            <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    No Metrics Selected
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Choose metrics from the control panel below to start viewing analytics data.
                </Typography>
            </Box>
        </Box>
    );
}

export function NoDataAvailableDisplay() {
    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            flexDirection: 'column',
            gap: 2,
            py: 4
        }}>
            <TrendingUpIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
            <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6" color="text.secondary" gutterBottom>
                    No Data Available
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    No data found for the selected metrics and time range. Try adjusting your selections or date range.
                </Typography>
            </Box>
        </Box>
    );
}